<template>
        <tr v-if="o === n">
            <td align="center"></td>
            <td align="center">
                <img :src="f ? path+f : ''" :width="width" :height="height" style="background-color: #f3f3f3" />
            </td>
            <td align="center"></td>
        </tr>
        <tr v-else>
            <td :class="{'selected': f === o}" align="center">
                <a @click="f = o">
                    <img :src="o ? path + o : ''"  :width="width" :height="height" style="background-color: #f3f3f3" />
                </a>
            </td>
            <td class="selected" align="center">
                <img :src="f ? path + f : ''"  :width="width" :height="height" style="background-color: #f3f3f3" />
            </td>
            <td :class="{'selected': f === n}" align="center">
                <a @click="f = n">
                    <img :src="n ? path + n : ''"  :width="width" :height="height" style="background-color: #f3f3f3" />
                </a>
            </td>
        </tr>
</template>
<script>
import Base from "../Base.vue";
import StrPropsFNO from "../StrPropsFNO.vue";
    export default {
        mixins:[Base,StrPropsFNO],
        data: function () {
            return {
              path: this.params.path,
              width: this.params.width ?? 150,
              height: this.params.height ?? 150,
            }
        },
    }
</script>